import type { VertiNodeTenantId } from "../../../core/schema/VertiNodeTenant.js";
import type { SharedGlobalSettings } from "../../shared/SharedGlobalSettings.js";
import type { VertiNodeLocale } from "../../../core/schema/VertiNodeLocale.js";

export const globalSettingsContextKey = "globalSettings";

export interface GlobalSettings extends Omit<SharedGlobalSettings, "TENANT_ID" | "TENANT_LOCALE"> {
	TENANT_ID: VertiNodeTenantId;
	TENANT_LOCALE: VertiNodeLocale;
	COOKIES: string;
	GOOGLE_ANALYTICS: string;
}
